import { GetClauseDto } from '../models/clauses.model';

export interface ClauseLibraryState {
  clauses: GetClauseDto[] | null;
  loadingClauses: boolean;
  creatingClause: boolean;
  closeCreatingClauseModal: boolean;
  deletingClause: boolean;
  clause: GetClauseDto | null;
  loadingClause: boolean;
  editingClause: boolean;
  closeEditingClauseModal: boolean;
}

export const initialState: ClauseLibraryState = {
  clauses: null,
  loadingClauses: false,
  creatingClause: false,
  closeCreatingClauseModal: false,
  deletingClause: false,
  clause: null,
  loadingClause: false,
  editingClause: false,
  closeEditingClauseModal: false,
};
